import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  employeeRoleDefinitions: [],
};

const employeeRoleModule = {
  state,
  mutations,
  actions,
  getters,
};

export default employeeRoleModule;
